<script setup lang="ts">
import ChqMenuGroup from "../../components/menu/ChqMenuGroup.vue";
import ChqMenuItem from '../../components/menu/ChqMenuItem.vue';
import { appVm, systemUser } from "../../main-store";

Object.assign(appVm.sidebarState, {
    clients: {
        checkin: false,
        medical: false,
        management: false,
        appointments: false
    }
});
</script>
<template>
    <h5>
        Clients
    </h5>
    <ul role="list" class="space-y-1">
        <li class="flex items-center">
            <a class="flex-grow" href="/chat" target="_self">
                <i class="fas fa-comments"></i> Chat
                <span class="badge ml-auto bg-red-600" v-show="appVm.chatCount > 0">{{ appVm.chatCount }}</span>
            </a>
        </li>

        <ChqMenuGroup :menu-group="appVm.sidebarState.clients.checkin" icon="fa-clipboard-list"
            name="Check In / Check Out">
            <ChqMenuItem menu-item="/checkout/queue">Check In / Checkout</ChqMenuItem>
            <ChqMenuItem menu-item="/checkout/quick-entry">Checkout Quick Entry</ChqMenuItem>
            <ChqMenuItem menu-item="/checkout/paperwork">Print / Email Paperwork</ChqMenuItem>
            <ChqMenuItem menu-item="/checkout/roster">Roster</ChqMenuItem>
            <ChqMenuItem menu-item="/checkout/online-appointments" disable-pin="true">Online Appointments</ChqMenuItem>
        </ChqMenuGroup>

        <ChqMenuGroup :menu-group="appVm.sidebarState.clients.medical" icon="fa-notes-medical" name="Medical">
            <ChqMenuItem menu-item="/medical/drug-log">Drug Logs</ChqMenuItem>
            <ChqMenuItem v-if="systemUser.clinic.enableAmTasksDrugLog" menu-item="/medical/am-tasks">AM Tasks
            </ChqMenuItem>
            <ChqMenuItem menu-item="/clients/idexx">Idexx Results</ChqMenuItem>
            <ChqMenuItem menu-item="/checkout/prescription-logs">Prescription Logs</ChqMenuItem>
            <ChqMenuItem menu-item="/clients/microchip-logs">Microchip Logs</ChqMenuItem>
            <ChqMenuItem menu-item="/checkout/recheck">Rechecks</ChqMenuItem>
        </ChqMenuGroup>

        <ChqMenuGroup :menu-group="appVm.sidebarState.clients.management" icon="fa-user" name="Client Management">
            <ChqMenuItem menu-item="/clients/search">Search Clients / Animals</ChqMenuItem>
            <ChqMenuItem menu-item="/clients/merge-clients">Merge Clients</ChqMenuItem>
            <ChqMenuItem menu-item="/clients/merge-animals">Merge Animals</ChqMenuItem>
            <ChqMenuItem menu-item="/clients/volume/create">Create Volume Client</ChqMenuItem>
            <ChqMenuItem menu-item="/clients/deposits">Manage Deposits</ChqMenuItem>
            <ChqMenuItem menu-item="/clients/communication-logs">Communication Logs</ChqMenuItem>
        </ChqMenuGroup>

        <ChqMenuGroup :menu-group="appVm.sidebarState.clients.appointments" icon="fa-calendar-day" name="Appointments">
            <ChqMenuItem menu-item="/clients/volume/appointments">Volume Client Appointments</ChqMenuItem>
            <ChqMenuItem menu-item="/checkout/scheduler-logs">Scheduler Logs</ChqMenuItem>
            <ChqMenuItem menu-item="/clients/auditing-logs">Auditing Logs</ChqMenuItem>
        </ChqMenuGroup>
    </ul>
</template>